<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">The author expresses his deep gratitude to</p>
<br/>
<p style="text-indent:0em;">- Lev Eppelbaum, Professor of the Department of Geophysics at Tel Aviv University, for consultations and valuable advice in the process of writing this book;</p>
<br/>
<p style="text-indent:0em;">- Valeria Mednikov, philologist and mathematician, for great help in translating the book and communicating with the Publishing House.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?dc345a52